import { SmallModal } from "@starrez/starryui";
import * as React from "react";
import { strings } from "../../localisation";
import { ButtonBarButton, ButtonBarCenter } from "../ButtonBar/ButtonBar.styles";
import { Button } from "../Buttons/Button";
import { ConfirmModalText } from "./WizardCloseConfirm.styles";

export interface IWizardCloseConfirmProps {
    SetIsClosing: (isClosing: boolean) => void;
}

export const WizardCloseConfirm = React.memo(({ SetIsClosing }: IWizardCloseConfirmProps) => {
    return (
        <SmallModal
            Header={`${strings.Message_WizardClose_CancelWizard}?`}
            OnCloseRequest={() => SetIsClosing(false)}
            ListenToBackgroundClick={false}
            RenderFooter={
                () => (
                    <ButtonBarCenter>
                        <ButtonBarButton>
                            <Button
                                variant={"Primary"}
                                onClick={() => SetIsClosing(false)}>
                                {strings.Message_WizardClose_KeepEditing}
                            </Button>
                        </ButtonBarButton>
                        <ButtonBarButton>
                            <Button
                                variant={"Tertiary"}
                                onClick={() => SetIsClosing(true)}>
                                {strings.Message_WizardClose_CancelWizard}
                            </Button>
                        </ButtonBarButton>
                    </ButtonBarCenter>
                )}>
            <ConfirmModalText>
                <p>
                    {strings.Message_WizardClose_Editing}
                </p>
                <p>
                    {strings.Message_WizardClose_Confirm}
                </p>
            </ConfirmModalText>
        </SmallModal>
    );
}, () => true);
